export default "__VITE_ASSET__B8afjR9R__"